import { render, staticRenderFns } from "./Level2-1.vue?vue&type=template&id=063063a4&scoped=true&"
import script from "./Level2-1.vue?vue&type=script&lang=js&"
export * from "./Level2-1.vue?vue&type=script&lang=js&"
import style0 from "./Level2-1.vue?vue&type=style&index=0&id=063063a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063063a4",
  null
  
)

export default component.exports